import * as types from "./types";

export const getLoyalApplicantsRequest = (payload) => ({
  type: types.GET_LOYAL_APPLICANTS_REQUEST,
  payload,
});

export const getLoyalApplicantsResponse = (payload) => ({
  type: types.GET_LOYAL_APPLICANTS_RESPONSE,
  payload,
});

export const bulkRemoveLoyalApplicantsRequest = (payload) => ({
  type: types.BULK_REMOVE_LOYAL_APPLICANTS_REQUEST,
  payload,
});
